import React, { useState, useEffect } from "react";
import config from "../../config/config.json";
import { Button, Form, Spinner, Table } from "react-bootstrap";
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from "react-places-autocomplete";
import { apiCall } from "../../_services/apiCall";
import Loader from "../loader/Loader";
import { Modal, ModalHeader } from "../../globalComponents/ui/Modal";
import { PrimaryButton, SecondaryButton, DangerButton } from "../../globalComponents/ui/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPlus, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import {
  SettingLayout,
  SettingsFilterCard, SettingsSearchWrap,
  SettingsCard, SettingsSectionHeader, SettingsSectionTitle, SettingsCountChip,
  SettingsEmptyState,
  SettingsModalBody, SettingsModalFooter,
  SettingsFormGroup, SettingsFormLabel, SettingsFormInput, SettingsFormGrid,
  SettingsActionsCell, SettingsActionBtn,
  SettingsFormSelect,
} from "./SettingShell";
import DataTable from "../../globalComponents/ui/DataTable/DataTable";

const LocationManagement = ({ tab, userPermissionList }) => {
  // ─── State (original) ────────────────────────────────────────────────────────
  const [unitName, setUnitName] = useState("");
  const [subLocationType, setSubLocationType] = useState("");
  const [subOtherLocationType, setSubOtherLocationType] = useState("");
  const [meterDataList, setMeterDataList] = useState([]);
  const [filterListValue, setFilterListValue] = useState([]);
  const [headOfficeTrueCount, setHeadOfficeTrueCount] = useState([]);
  const [headOfficeFalseCount, setHeadOfficeFalseCount] = useState([]);
  const [address, setAddress] = useState("");
  const [showSkelton, setshowSkelton] = useState(false);
  const [mode, setMode] = useState("create");
  const [showAddLocation, setAddLocationShow] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [spinner, setSpinner] = useState(false);
  const [deleteLocationPopup, setDeleteLocationPopup] = useState(false);
  const [unitLocationPopup, setUnitLocationPopup] = useState(false);
  const [confirmUnitPopup, setConfirmUnitPopup] = useState(false);
  const [unitLocationDataPopup, setUnitLocationDataPopup] = useState(false);
  const [unitData, setUnitData] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState({
    area: "", city: "", state: "", country: "", zipCode: "", locationType: "", otherLocationType: ""
  });
  const [selectedUnitCode, setSelectedUnitCode] = useState("");
  const [selectedTypeFilter, setSelectedTypeFilter] = useState("all");

  const userId = JSON.parse(localStorage.getItem("user_temp_id"));

  // ─── Permission checks (original codes) ─────────────────────────────────────
  const canCreate = userPermissionList.some(p => p.permissionCode === "CREATE" && p.checked);
  const canEdit = userPermissionList.some(p => p.permissionCode === "EDIT" && p.checked);
  const canDelete = userPermissionList.some(p => p.permissionCode === "DELETE" && p.checked);

  // ─── Modal helpers ────────────────────────────────────────────────────────────
  const closeDeleteLocationPopup = () => setDeleteLocationPopup(false);
  const closeUnitLocationPopup = () => {
    setUnitLocationPopup(false);
    setUnitName("");
    setSubLocationType("");
    setSubOtherLocationType("");
  };
  const closeConfirmUnitPopup = () => setConfirmUnitPopup(false);
  const closeUnitLocationDataPopup = () => setUnitLocationDataPopup(false);

  const handleAddLocationShow = () => { setMode("create"); setAddLocationShow(true); };

  const handleEditLocationShow = (id, location, unitCode) => {
    setMode("edit");
    setSelectedId(id);
    setAddress(location.area);
    setSelectedLocation({
      area: location.area || "",
      city: location.city || "",
      state: location.state || "",
      country: location.country || "",
      zipCode: location.zipCode || "",
      locationType: location.locationType || "",
      otherLocationType: location.otherLocationType || "",
    });
    setSelectedUnitCode(unitCode || "");
    setAddLocationShow(true);
  };

  const handleClose = () => {
    setMode("create");
    setAddLocationShow(false);
    setAddress("");
    setSelectedLocation({ area: "", city: "", state: "", country: "", zipCode: "", locationType: "", otherLocationType: "" });
    setSelectedUnitCode("");
  };

  const showUnitLocationPopup = (id) => { setSelectedId(id); setUnitLocationPopup(true); };
  const showDeleteLocationPopup = (id) => { setSelectedId(id); setDeleteLocationPopup(true); };

  const handleImageClick = (subLocation) => {
    setUnitData(subLocation);
    setUnitLocationDataPopup(true);
  };

  const handleConfirmUnit = () => { if (unitName.trim()) setConfirmUnitPopup(true); };

  // ─── API calls (original, untouched) ─────────────────────────────────────────
  const getSource = async () => {
    setshowSkelton(true);
    const { isSuccess, data } = await apiCall(
      `${config.POSTLOGIN_API_URL_COMPANY}getSource`,
      {},
      { userId },
      "GET"
    );
    if (isSuccess) {
      setshowSkelton(false);
      const reversed = data?.data?.reverse() || [];
      setMeterDataList(reversed);
      
      let filtered = [...reversed];
      if (selectedTypeFilter && selectedTypeFilter !== "all") {
        filtered = filtered.filter(item => {
          const itemType = item.location?.locationType || (item.head_Office ? "Corporate HeadQUaters" : "");
          return itemType === selectedTypeFilter;
        });
      }
      setFilterListValue(filtered);

      setHeadOfficeTrueCount(reversed.filter(item => item.head_Office === true || item.location?.locationType === "Corporate HeadQUaters"));
      setHeadOfficeFalseCount(reversed.filter(item => item.head_Office !== true && item.location?.locationType !== "Corporate HeadQUaters"));
    }
  };

  const createSource = async () => {
    setSpinner(true);
    const { isSuccess } = await apiCall(
      config.POSTLOGIN_API_URL_COMPANY + `createSource`,
      {},
      { location: JSON.stringify(selectedLocation), unitCode: selectedUnitCode },
      "POST"
    );
    setSpinner(false);
    if (isSuccess) {
      getSource();
      setAddress("");
      setSelectedLocation({ area: "", city: "", state: "", country: "", zipCode: "", locationType: "", otherLocationType: "" });
      setSelectedUnitCode("");
      handleClose();
    }
  };

  const updateSource = async () => {
    setSpinner(true);
    const { isSuccess } = await apiCall(
      config.POSTLOGIN_API_URL_COMPANY + `updateSource`,
      {},
      { location: JSON.stringify(selectedLocation), id: selectedId, unitCode: selectedUnitCode },
      "POST"
    );
    setSpinner(false);
    if (isSuccess) {
      getSource();
      setAddress("");
      setSelectedLocation({ area: "", city: "", state: "", country: "", zipCode: "", locationType: "", otherLocationType: "" });
      handleClose();
    }
  };

  const deleteSource = async () => {
    const { isSuccess } = await apiCall(
      config.POSTLOGIN_API_URL_COMPANY + `deleteSource`,
      {},
      { id: selectedId },
      "POST"
    );
    if (isSuccess) { getSource(); closeDeleteLocationPopup(); }
  };

  const handleAddUnit = async () => {
    if (unitName.trim()) {
      setSpinner(true);
      const { isSuccess } = await apiCall(
        config.POSTLOGIN_API_URL_COMPANY + `createSubLocation`,
        {},
        {
          subLocation: unitName,
          locationId: selectedId,
          location_type: subLocationType || null,
          other_location_type: subLocationType === "other" ? subOtherLocationType : null
        },
        "POST"
      );
      setSpinner(false);
      if (isSuccess) {
        getSource();
        setUnitName("");
        setSubLocationType("");
        setSubOtherLocationType("");
        closeConfirmUnitPopup();
        closeUnitLocationPopup();
      }
    }
  };

  // ─── Places autocomplete handlers (original) ──────────────────────────────────
  const handleChange = (newAddress) => setAddress(newAddress);

  const handleSelect = async (selectedAddress) => {
    try {
      const results = await geocodeByAddress(selectedAddress);
      await getLatLng(results[0]);
      const components = results[0].address_components;
      const localityIndex = components.findIndex(c => c.types.includes("locality"));
      const area = components.slice(0, localityIndex).map(c => c.long_name).join(", ");
      const city = components.find(c => c.types.includes("locality"))?.long_name || "";
      const state = components.find(c => c.types.includes("administrative_area_level_1"))?.long_name || "";
      const country = components.find(c => c.types.includes("country"))?.long_name || "";
      const zipCode = components.find(c => c.types.includes("postal_code"))?.long_name || "";
      setAddress(area);
      setSelectedLocation(prev => ({
        ...prev,
        area, city, state, country, zipCode
      }));
    } catch (err) {
      console.error("Error selecting location", err);
    }
  };

  const handleManualInputChange = (field, value) => {
    setSelectedLocation(prev => ({ ...prev, [field]: value }));
  };

  // ─── Search & Dropdown Filter ──────────────────────────────────────────────────
  const handleSearch = (searchTerm, typeFilter = selectedTypeFilter) => {
    const q = searchTerm.trim().toLowerCase();
    let filtered = [...meterDataList];

    if (typeFilter && typeFilter !== "all") {
      filtered = filtered.filter(item => {
        const itemType = item.location?.locationType || (item.head_Office ? "Corporate HeadQUaters" : "");
        return itemType === typeFilter;
      });
    }

    if (q) {
      filtered = filtered.filter(item => {
        const loc = item.location || {};
        return (
          (loc.area || "").toLowerCase().includes(q) ||
          (loc.city || "").toLowerCase().includes(q) ||
          (loc.state || "").toLowerCase().includes(q) ||
          (loc.country || "").toLowerCase().includes(q) ||
          (loc.zipCode || "").toLowerCase().includes(q) ||
          (item.unitCode || "").toLowerCase().includes(q)
        );
      });
    }

    setFilterListValue(filtered);
  };

  const handleFilterTypeChange = (value) => {
    setSelectedTypeFilter(value);
    const searchInput = document.querySelector('input[type="search"]');
    handleSearch(searchInput ? searchInput.value : "", value);
  };

  useEffect(() => { getSource(); }, [tab]);

  // ─── Helper to build address string for DataTable ─────────────────────────────
  const formatAddress = (loc) =>
    [loc?.area, loc?.city, loc?.state, loc?.country, loc?.zipCode]
      .filter(Boolean).join(", ");

  // ─── Render ───────────────────────────────────────────────────────────────────
  return (
    <SettingLayout
      title="Location Management"
      subtitle={`${meterDataList.length} locations configured`}
      $wide
      rightContent={
        canCreate && (
          <PrimaryButton onClick={handleAddLocationShow}>
            <i className="fas fa-plus" aria-hidden="true" style={{ marginRight: 6 }} />
            Add Location
          </PrimaryButton>
        )
      }
    >
      {/* Search & Filter Dropdown */}
      <SettingsFilterCard>
        <SettingsSearchWrap style={{ flex: 3 }}>
          <i className="fas fa-search s-icon" aria-hidden="true" />
          <input
            type="search"
            placeholder="Search locations..."
            onChange={e => handleSearch(e.target.value)}
          />
        </SettingsSearchWrap>
        <div style={{ flex: 1, minWidth: "200px" }}>
          <SettingsFormSelect
            value={selectedTypeFilter}
            onChange={e => handleFilterTypeChange(e.target.value)}
            style={{ height: "38px", border: "1.5px solid #e2e8f0", borderRadius: 9 }}
          >
            <option value="all">All Location Types</option>
            <option value="Corporate HeadQUaters">Corporate Headquarters</option>
            <option value="Regional Offices">Regional Offices</option>
            <option value="Agricultural Sites">Agricultural Sites</option>
            <option value="other">Other</option>
          </SettingsFormSelect>
        </div>
      </SettingsFilterCard>

      {showSkelton ? (
        <div style={{ padding: 40 }}><Loader /></div>
      ) : (
        (() => {
          const filteredHeadOfficeTrue = filterListValue.filter(
            item => item.head_Office === true || item.location?.locationType === "Corporate HeadQUaters"
          );
          const filteredHeadOfficeFalse = filterListValue.filter(
            item => item.head_Office !== true && item.location?.locationType !== "Corporate HeadQUaters"
          );

          return (
            <>
              {/* ── Corporate Headquarters ─────────────────────────────────────── */}
              <SettingsCard style={{ marginBottom: 20 }}>
                <SettingsSectionHeader>
                  <i className="fas fa-building" style={{ fontSize: 12, color: "#3f88a5" }} />
                  <SettingsSectionTitle>Corporate Headquarters</SettingsSectionTitle>
                  <SettingsCountChip>{filteredHeadOfficeTrue.length}</SettingsCountChip>
                </SettingsSectionHeader>

                {filteredHeadOfficeTrue.length > 0 ? (
                  <DataTable
                    title=""
                    searchable={false}
                    showPagination={false}
                    columns={[
                      { key: "address", label: "Corporate Headquarters Address", sortable: true },
                      { key: "locationType", label: "Location Type" },
                      { key: "unitCode", label: "Unit Code" },
                    ]}
                    data={filteredHeadOfficeTrue.map(row => ({
                      _id: row.id,
                      address: formatAddress(row.location),
                      locationType: row.location?.locationType === "other"
                        ? `Other (${row.location?.otherLocationType || ""})`
                        : (row.location?.locationType === "Corporate HeadQUaters"
                          ? "Corporate Headquarters"
                          : row.location?.locationType || "Corporate Headquarters"),
                      unitCode: row.unitCode || "—",
                      _raw: row,
                    }))}
                    extraActions={(row) => [
                      ...(canEdit ? [{ label: "Edit", icon: "fas fa-edit", variant: "edit", onClick: () => handleEditLocationShow(row._raw.id, row._raw.location, row._raw.unitCode) }] : []),
                      { label: "Add Sub-location", icon: "fas fa-plus", variant: "edit", onClick: () => showUnitLocationPopup(row._raw.id) },
                      ...(row._raw.subLocation?.length ? [{ label: "View sub-locations", icon: "fas fa-eye", variant: "view", onClick: () => handleImageClick(row._raw.subLocation) }] : []),
                    ]}
                  />
                ) : (
                  <div style={{ padding: 20, textAlign: "center", fontSize: 13, color: "#94a3b8" }}>
                    No headquarters defined.
                  </div>
                )}
              </SettingsCard>

              {/* ── Regional Offices ───────────────────────────────────────────── */}
              <SettingsCard>
                <SettingsSectionHeader>
                  <i className="fas fa-map-marker-alt" style={{ fontSize: 12, color: "#3f88a5" }} />
                  <SettingsSectionTitle>Regional Offices</SettingsSectionTitle>
                  <SettingsCountChip>{filteredHeadOfficeFalse.length}</SettingsCountChip>
                </SettingsSectionHeader>

                {filteredHeadOfficeFalse.length > 0 ? (
                  <DataTable
                    title=""
                    searchable={false}
                    showPagination={filteredHeadOfficeFalse.length > 20}
                    columns={[
                      { key: "address", label: "Regional Office Address", sortable: true },
                      { key: "locationType", label: "Location Type" },
                      { key: "unitCode", label: "Unit Code" },
                    ]}
                    data={filteredHeadOfficeFalse.map(row => ({
                      _id: row.id,
                      address: formatAddress(row.location),
                      locationType: row.location?.locationType === "other"
                        ? `Other (${row.location?.otherLocationType || ""})`
                        : (row.location?.locationType === "Corporate HeadQUaters"
                          ? "Corporate Headquarters"
                          : row.location?.locationType || "Regional Office"),
                      unitCode: row.unitCode || "—",
                      _raw: row,
                    }))}
                    extraActions={(row) => [
                      ...(row._raw.is_deletable && canEdit ? [{ label: "Edit", icon: "fas fa-edit", variant: "edit", onClick: () => handleEditLocationShow(row._raw.id, row._raw.location, row._raw.unitCode) }] : []),
                      ...(row._raw.is_deletable && canDelete ? [{ label: "Delete", icon: "fas fa-trash", variant: "del", onClick: () => showDeleteLocationPopup(row._raw.id) }] : []),
                      { label: "Add Sub-location", icon: "fas fa-plus", variant: "edit", onClick: () => showUnitLocationPopup(row._raw.id) },
                      ...(row._raw.subLocation?.length ? [{ label: "View sub-locations", icon: "fas fa-eye", variant: "view", onClick: () => handleImageClick(row._raw.subLocation) }] : []),
                    ]}
                  />
                ) : (
                  <SettingsEmptyState>
                    <i className="fas fa-map-pin s-empty-icon" />
                    <div className="s-empty-title">No regional offices found</div>
                    <div className="s-empty-sub">Add locations to track data across different areas.</div>
                  </SettingsEmptyState>
                )}
              </SettingsCard>
            </>
          );
        })()
      )}

      {/* ── Add / Edit Location Modal ────────────────────────────────────────── */}
      <Modal show={showAddLocation} onClose={handleClose} maxWidth={520}>
        <ModalHeader
          icon="fas fa-map-marker-alt"
          title={mode === "create" ? "Add New Location" : "Update Location"}
          subtitle="Search for an address to auto-fill the fields below"
          onClose={handleClose}
        />
        <SettingsModalBody>
          {/* Google Places search */}
          <SettingsFormGroup>
            <SettingsFormLabel>Search Address *</SettingsFormLabel>
            <PlacesAutocomplete value={address} onChange={handleChange} onSelect={handleSelect}>
              {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                <div style={{ position: "relative" }}>
                  <SettingsFormInput
                    {...getInputProps({ placeholder: "Type your location...", className: "location-search-input" })}
                  />
                  {(loading || suggestions.length > 0) && (
                    <div style={{ position: "absolute", zIndex: 1000, background: "#fff", width: "100%", border: "1px solid #e2e8f0", borderRadius: 8, marginTop: 4, overflow: "hidden", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
                      {loading && <div style={{ padding: "10px 14px", fontSize: 12, color: "#64748b" }}>Loading...</div>}
                      {suggestions.map((s, i) => (
                        <div key={i} {...getSuggestionItemProps(s, { style: { padding: "10px 14px", fontSize: 12.5, cursor: "pointer", background: s.active ? "#f0f9ff" : "#fff", borderBottom: "1px solid #f1f5f9" } })}>
                          <i className="fas fa-map-pin" style={{ marginRight: 8, color: "#3f88a5", fontSize: 11 }} />
                          {s.description}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </PlacesAutocomplete>
          </SettingsFormGroup>

          {/* Address fields */}
          <div style={{ marginTop: 8, padding: 16, background: "#f8fafc", borderRadius: 10, border: "1px solid #e2e8f0" }}>
            <SettingsFormGrid>
              <SettingsFormGroup>
                <SettingsFormLabel>City</SettingsFormLabel>
                <SettingsFormInput
                  placeholder="Enter City"
                  value={selectedLocation.city}
                  onChange={e => handleManualInputChange("city", e.target.value)}
                  readOnly
                />
              </SettingsFormGroup>
              <SettingsFormGroup>
                <SettingsFormLabel>State</SettingsFormLabel>
                <SettingsFormInput
                  placeholder="Enter State"
                  value={selectedLocation.state}
                  onChange={e => handleManualInputChange("state", e.target.value)}
                  readOnly
                />
              </SettingsFormGroup>
            </SettingsFormGrid>
            <SettingsFormGrid style={{ marginTop: 12 }}>
              <SettingsFormGroup>
                <SettingsFormLabel>Country</SettingsFormLabel>
                <SettingsFormInput
                  placeholder="Enter Country"
                  value={selectedLocation.country}
                  onChange={e => handleManualInputChange("country", e.target.value)}
                  readOnly
                />
              </SettingsFormGroup>
              <SettingsFormGroup>
                <SettingsFormLabel>Zip Code</SettingsFormLabel>
                <SettingsFormInput
                  placeholder="Enter Zip Code"
                  value={selectedLocation.zipCode}
                  onChange={e => handleManualInputChange("zipCode", e.target.value)}
                  readOnly
                />
              </SettingsFormGroup>
            </SettingsFormGrid>
            <SettingsFormGroup style={{ marginTop: 12 }}>
              <SettingsFormLabel>Unit Code</SettingsFormLabel>
              <SettingsFormInput
                placeholder="Enter Unit Code"
                value={selectedUnitCode}
                onChange={e => setSelectedUnitCode(e.target.value)}
              />
            </SettingsFormGroup>

            <SettingsFormGroup style={{ marginTop: 12 }}>
              <SettingsFormLabel>Location Type *</SettingsFormLabel>
              <SettingsFormSelect
                value={selectedLocation.locationType}
                onChange={e => handleManualInputChange("locationType", e.target.value)}
              >
                <option value="">Select Location Type</option>
                <option value="Corporate HeadQUaters">Corporate Headquarters</option>
                <option value="Regional Offices">Regional Offices</option>
                <option value="Agricultural Sites">Agricultural Sites</option>
                <option value="other">Other</option>
              </SettingsFormSelect>
            </SettingsFormGroup>

            {selectedLocation.locationType === "other" && (
              <SettingsFormGroup style={{ marginTop: 12 }}>
                <SettingsFormLabel>Please Specify *</SettingsFormLabel>
                <SettingsFormInput
                  placeholder="Enter location type"
                  value={selectedLocation.otherLocationType}
                  onChange={e => handleManualInputChange("otherLocationType", e.target.value)}
                />
              </SettingsFormGroup>
            )}
          </div>
        </SettingsModalBody>
        <SettingsModalFooter>
          <SecondaryButton onClick={handleClose}>Cancel</SecondaryButton>
          <PrimaryButton
            disabled={
              spinner ||
              !selectedLocation.zipCode ||
              !selectedLocation.locationType ||
              (selectedLocation.locationType === "other" && !selectedLocation.otherLocationType?.trim())
            }
            onClick={mode === "create" ? createSource : updateSource}
          >
            {spinner
              ? <><Spinner animation="border" size="sm" style={{ marginRight: 6 }} />{mode === "create" ? "Creating..." : "Updating..."}</>
              : (mode === "create" ? "Create Location" : "Update Location")
            }
          </PrimaryButton>
        </SettingsModalFooter>
      </Modal>

      {/* ── Delete Confirmation ──────────────────────────────────────────────── */}
      <Modal show={deleteLocationPopup} onClose={closeDeleteLocationPopup} maxWidth={400}>
        <ModalHeader icon="fas fa-exclamation-triangle" title="Confirm Delete" onClose={closeDeleteLocationPopup} />
        <SettingsModalBody>
          <p style={{ margin: 0, fontSize: 13, color: "#475569" }}>Are you sure you want to delete this location?</p>
        </SettingsModalBody>
        <SettingsModalFooter>
          <SecondaryButton onClick={closeDeleteLocationPopup}>Cancel</SecondaryButton>
          <DangerButton onClick={deleteSource}>Delete</DangerButton>
        </SettingsModalFooter>
      </Modal>

      {/* ── Add Sub-location Modal ───────────────────────────────────────────── */}
      <Modal show={unitLocationPopup} onClose={closeUnitLocationPopup} maxWidth={420}>
        <ModalHeader icon="fas fa-plus" title="Add Sub-location" onClose={closeUnitLocationPopup} />
        <SettingsModalBody>
          <SettingsFormGroup>
            <SettingsFormLabel>Unit Name</SettingsFormLabel>
            <SettingsFormInput
              type="text"
              placeholder="Enter unit name"
              value={unitName}
              onChange={e => setUnitName(e.target.value)}
            />
          </SettingsFormGroup>

          <SettingsFormGroup style={{ marginTop: 12 }}>
            <SettingsFormLabel>Location Type *</SettingsFormLabel>
            <SettingsFormSelect
              value={subLocationType}
              onChange={e => setSubLocationType(e.target.value)}
            >
              <option value="">Select Location Type</option>
              <option value="Corporate HeadQUaters">Corporate Headquarters</option>
              <option value="Regional Offices">Regional Offices</option>
              <option value="Agricultural Sites">Agricultural Sites</option>
              <option value="other">Other</option>
            </SettingsFormSelect>
          </SettingsFormGroup>

          {subLocationType === "other" && (
            <SettingsFormGroup style={{ marginTop: 12 }}>
              <SettingsFormLabel>Please Specify *</SettingsFormLabel>
              <SettingsFormInput
                placeholder="Enter location type"
                value={subOtherLocationType}
                onChange={e => setSubOtherLocationType(e.target.value)}
              />
            </SettingsFormGroup>
          )}
        </SettingsModalBody>
        <SettingsModalFooter>
          <SecondaryButton onClick={closeUnitLocationPopup}>Cancel</SecondaryButton>
          <PrimaryButton
            disabled={
              !unitName.trim() ||
              !subLocationType ||
              (subLocationType === "other" && !subOtherLocationType.trim())
            }
            onClick={handleConfirmUnit}
          >
            Review
          </PrimaryButton>
        </SettingsModalFooter>
      </Modal>

      {/* ── Confirm Sub-location ─────────────────────────────────────────────── */}
      <Modal show={confirmUnitPopup} onClose={closeConfirmUnitPopup} maxWidth={420}>
        <ModalHeader icon="fas fa-check-circle" title="Confirm Unit Addition" onClose={closeConfirmUnitPopup} />
        <SettingsModalBody>
          <p style={{ margin: 0, fontSize: 13, color: "#475569" }}>
            Are you sure you want to add the unit <strong>"{unitName}"</strong>?
          </p>
        </SettingsModalBody>
        <SettingsModalFooter>
          <SecondaryButton onClick={closeConfirmUnitPopup}>Go Back</SecondaryButton>
          <PrimaryButton disabled={spinner} onClick={handleAddUnit}>
            {spinner
              ? <><Spinner animation="border" size="sm" style={{ marginRight: 6 }} />Saving...</>
              : "Confirm & Save"
            }
          </PrimaryButton>
        </SettingsModalFooter>
      </Modal>

      {/* ── View Sub-locations Modal ─────────────────────────────────────────── */}
      <Modal show={unitLocationDataPopup} onClose={closeUnitLocationDataPopup} maxWidth={520}>
        <ModalHeader icon="fas fa-eye" title="Sub-locations" onClose={closeUnitLocationDataPopup} />
        <SettingsModalBody>
          {unitData?.length > 0 ? (
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
              <thead>
                <tr style={{ borderBottom: "2px solid #e2e8f0" }}>
                  <th style={{ padding: "8px 12px", textAlign: "left", color: "#64748b", fontWeight: 600 }}>S.No</th>
                  <th style={{ padding: "8px 12px", textAlign: "left", color: "#64748b", fontWeight: 600 }}>Unit Name</th>
                  <th style={{ padding: "8px 12px", textAlign: "left", color: "#64748b", fontWeight: 600 }}>Location Type</th>
                </tr>
              </thead>
              <tbody>
                {unitData.map((unit, index) => (
                  <tr key={unit.id} style={{ borderBottom: "1px solid #f1f5f9" }}>
                    <td style={{ padding: "10px 12px", color: "#94a3b8" }}>{index + 1}</td>
                    <td style={{ padding: "10px 12px", color: "#1e293b", fontWeight: 500 }}>{unit?.subLocation}</td>
                    <td style={{ padding: "10px 12px", color: "#1e293b" }}>
                      {unit?.location_type === "other"
                        ? `Other (${unit?.other_location_type || ""})`
                        : (unit?.location_type === "Corporate HeadQUaters"
                          ? "Corporate Headquarters"
                          : unit?.location_type || "—")}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p style={{ margin: 0, textAlign: "center", color: "#94a3b8", fontSize: 13 }}>No sub-locations available.</p>
          )}
        </SettingsModalBody>
        <SettingsModalFooter>
          <SecondaryButton onClick={closeUnitLocationDataPopup}>Close</SecondaryButton>
        </SettingsModalFooter>
      </Modal>
    </SettingLayout>
  );
};

export default LocationManagement;